let Masonry = require('masonry-layout');
let Scroll  = require('../components/Scroll');

class Gallery {
    constructor() {
        this._grid = document.getElementsByClassName('js-gallery')[0];

        this._current = {
            elem: null,
            isOpen: false
        };

        this._items       = document.getElementsByClassName('gallery-item');
        this._itemsClosed = 0;

        this._columnWidth    = document.getElementsByClassName('gallery-sizer')[0].offsetWidth;
        this._gutter         = 15;
        this._maxColumnWidth = (this._columnWidth * 2) - this._gutter;

        if (window.innerWidth <= 1024) {
            this._maxColumnWidth = window.innerWidth - 23;
        }

        this._clicked = false;

        this._gallery = document.getElementById('gallery');

        this._galleryTop = this._gallery.offsetTop;

        this._newMore = document.createElement('div');

        this._addHash = false;

        this._createListener();

        this._setInfo()
    }

    _createListener() {
        window.addEventListener('resize', () => {
            this._galleryTop = this._gallery.offsetTop;

            this._columnWidth = document.getElementsByClassName('gallery-sizer')[0].offsetWidth;
            if (window.innerWidth <= 1024) {
                this._maxColumnWidth = window.innerWidth - 23;
            } else {
                this._maxColumnWidth = (this._columnWidth * 2) - this._gutter;
            }

            this._masonry.layout();
        });

        this._masonry = new Masonry(this._grid, {
            columnWidth: '.gallery-sizer',
            percentPosition: true,
            transitionDuration: 0
        });

        window.addEventListener('hashchange', () => {
            if (!this._addHash) {
                this._goToHash();
            }
        });

        this._goToHash();

        for (let item of this._items) {
            item.addEventListener('click', () => {
                if (!this._clicked) {
                    if (this._current.elem !== null) {
                        let elem = this._current.elem;
                        this._removeFull(item, () => {
                            if (this._itemsClosed === 1 && elem !== item) {
                                this._toggleElement(item);
                            }
                        });
                    } else {
                        this._toggleElement(item);
                    }

                    this._itemsClosed = 0;
                    this._clicked     = true;
                }
            })
        }
    }

    _toggleElement(item) {
        if (this._current.elem === item && this._current.isOpen) {
            this._close(item);
        } else {
            this._open(item);
        }
    }

    _goToHash() {
        let hash = window.location.hash;

        if (hash !== '') {
            this._open(document.querySelector(hash));
        }
    }

    _setInfo() {
        let infos = document.getElementsByClassName('js-info-gallery')[0];

        while (infos.children.length > 1) {
            this._newMore.appendChild(infos.children[0]);
        }

        this._newMore.classList.add('to-hide');
        this._newMore.classList.add('js-to-hide');

        infos.insertBefore(this._newMore, infos.children[1]);
    }

    _removeFull(itemClicked, callback = () => {
    }) {
        for (let item of this._items) {
            this._close(item, callback);
        }
    }

    _setSize(item, endWidth, setPosition = true, callback = () => {
    }) {
        let currentWidth = item.offsetWidth;
        let increase     = endWidth > currentWidth;

        let i = 1;

        if (item === this._current.elem || currentWidth === this._maxColumnWidth) {
            let interval = setInterval(() => {
                if (parseInt(item.style.width) === endWidth) {
                    clearInterval(interval);
                    this._clicked = false;
                    if (increase) {
                        this._showInfo(item);
                    } else {
                        item.classList.remove('open');
                        this._current.elem = null;

                        this._itemsClosed++;

                        callback();
                    }

                    if (setPosition) {
                        const TOP = Math.round(this._galleryTop + parseInt(item.style.top));
                        new Scroll().to(TOP, null, true);
                    }

                } else {
                    let newWidth = currentWidth;
                    if (increase) {
                        newWidth += i;
                    } else {
                        newWidth -= i;
                    }

                    if ((newWidth > endWidth && increase) || (newWidth < endWidth && !increase)) {
                        newWidth = endWidth;
                    }
                    item.style.width = newWidth + 'px';
                    i += 10;
                    this._masonry.layout();
                }
            }, 10);
        }
    }

    _animateInfo(item, endHeight, callback = () => {
    }) {
        let increase = item.offsetHeight < endHeight;
        let i        = (increase) ? 1 : parseInt(item.style.maxHeight);

        if (item.parentElement === this._current.elem) {
            let interval = setInterval(() => {
                if (parseInt(item.style.maxHeight) === endHeight) {
                    clearInterval(interval);
                    callback();
                } else {
                    let newHeight = i;

                    if ((newHeight > endHeight && increase) || (newHeight < endHeight && !increase)) {
                        newHeight = endHeight;
                    }

                    item.style.maxHeight = newHeight + 'px';
                    if (increase) {
                        i += 10;
                    } else {
                        i -= 10;
                    }

                    this._masonry.layout();
                }
            }, 10);
        }
    }

    _showInfo(item) {
        let info = item.getElementsByClassName('js-info-item')[0];

        this._animateInfo(info, info.scrollHeight)
    }

    _hideInfo(item, callback = () => {
    }) {
        let info = item.getElementsByClassName('js-info-item')[0];

        this._animateInfo(info, 0, callback);
    }

    _open(item) {
        this._current.isOpen = true;
        this._current.elem   = item;
        item.classList.add('open');

        let hash = window.location.hash;
        if (hash === '') {
            window.location.hash = item.id;
            this._addHash        = true;
        }

        this._setSize(item, this._maxColumnWidth);
    }

    _close(item, callback = () => {
    }) {
        if (this._current.elem === item) {
            this._current.isOpen = false;
        }

        window.history.pushState('', '/', window.location.pathname);
        this._addHash = false;

        this._hideInfo(item, () => this._setSize(item, this._columnWidth - this._gutter, false, callback));
    }

}

module.exports = Gallery;